import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import React from 'react'
import { createRoot } from 'react-dom/client'

import { QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'

// CSS
import { queryClient } from '@/lib/react-query'
import store from '@/stores'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-toastify/dist/ReactToastify.css'
import CSSReset from './theme/CSSReset'

import ErrorPage from '@/components/Page/ErrorPage'

import App from './App'

// import { tabsTheme } from './theme/components/Tabs';
const styles = {
  global: {
    ':not(.chakra-dont-set-collapse) > .chakra-collapse': {
      overflow: 'initial !important',
    },
  },
}
const theme = extendTheme({
  CSSReset,
  styles,
  fontSizes: {
    md: '0.9rem',
  },
  fonts: {
    body: `-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif`,
  },

  components: {
    Button: {
      variants: {
        ghost: {
          _hover: {
            bg: 'white',
            borderColor: 'transparent',
          },
          _focus: {
            bg: 'white',
            borderColor: 'transparent',
          },
          _active: {
            bg: 'white',
            borderColor: 'transparent',
          },
        },
      },
    },
    Tabs: {
      variants: {
        'soft-rounded': {
          tab: {
            _disabled: {
              color: 'hsl(0, 0%, 60%)',
              cursor: 'not-allowed',
            },
          },
        },
      },
    },
    Input: {
      variants: {
        outline: {
          field: {
            _disabled: {
              backgroundColor: 'hsl(0, 0%, 95%)',
              opacity: 1,
              color: 'hsl(0, 0%, 50%)',
              cursor: 'pointer',
            },
          },
        },
      },
    },
    Textarea: {
      variants: {
        outline: {
          _disabled: {
            backgroundColor: 'hsl(0, 0%, 95%)',
            opacity: 1,
            color: 'hsl(0, 0%, 50%)',
            cursor: 'pointer',
          },
        },
      },
    },
  },
})

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <React.StrictMode>
    <React.Suspense fallback={<div>Loading....</div>}>
      <ChakraProvider theme={theme}>
        <ErrorBoundary FallbackComponent={ErrorPage}>
          <HelmetProvider>
            <QueryClientProvider client={queryClient}>
              <Provider store={store}>
                <App />
                <ToastContainer style={{ width: '700px' }} pauseOnFocusLoss={false} position="top-center" limit={2} />
              </Provider>
            </QueryClientProvider>
          </HelmetProvider>
        </ErrorBoundary>
      </ChakraProvider>
    </React.Suspense>
  </React.StrictMode>
)
